import { BASE_URL } from '../../constants/endpoints';

export const STYLES = {
  APP_LAYOUT: {
    STYLE:
      'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
    NAVBAR: 'flex items-start mb-6 mt-[18px]',
    NAV_TITLE: 'font-metricMedium text-xl ml-[1rem]',
    BACK_BUTTON: 'flex items-center justify-center w-[2rem] h-[2rem]',
  },
  FLOW_MANAGER: {
    WRAPPER: 'flex items-center gap-[24px] h-[600px] fadeIn',
  },
  SIDE_BAR: {
    WRAPPER: 'flex flex-col py-[40px] px-[40px] h-full w-[264px] bg-bw00 rounded-[8px] shadow-light fadeIn',
    BUTTON: 'relative pb-[16px] mb-[24px] border-b border-b-bw03 text-left font-metricR text-[16px] text-bw08',
    INDICATOR: 'absolute h-full w-[4px] bg-action03 left-0 top-0 translate-x-[-40px] fadeIn',
  },
  GENERATE: {
    WRAPPER: 'w-[456px] h-full rounded-[8px] bg-bw00 shadow-light',
  },
  PREVIEW: {
    WRAPPER: 'py-[40px] px-[40px] flex flex-col h-full',
    TOP_BAR_CONTAINER: 'flex items-center justify-between pb-[8px] border-b border-b-bw03 mb-[24px]',
    TOP_BAR_HEADER: 'font-metricRMedium text-bw08 text-[20px]',
    TOP_BAR_ACTIONS_CONTAINER: 'flex items-center gap-[16px]',
    IFRAME_CONTAINER: 'w-full h-full flex items-center justify-center fadeIn',
    IFRAME: 'h-full w-full',
  },
  GENERATE_AVAILABLE: {
    WRAPPER: 'w-full h-full flex flex-col py-[40px] px-[40px]',
    ICON: 'mb-[28px]',
    HEADER: 'font-metricRMedium text-[25px] text-bw08',
    SUBHEADER: 'font-metricR text-[16px] text-bw07 mb-[34px]',
    DISCLAIMER: 'font-metricR text-[16px] text-bw06',
    ACTION: 'w-[250px] text-[14px] mt-auto',
  },
  CATEGORIZE: {
    WRAPPER: 'w-full h-full py-[25px] px-[40px] flex flex-col gap-[32px] items-center justify-center',
    HEADER: 'font-metricR text-[16px] text-bw07 text-center',
    CONTAINER: 'w-full h-fit flex flex-col items-center justify-center bg-bw00 rounded-lg pt-[2px] pb-[18px] relative',
    NAV_SWITCH:
      'flex items-center gap-[6px] w-[280px] py-[4px] px-[2px] bg-bw02 border-[2px] border-bw03 rounded-[8px] mb-[34px]',
  },
  INTRO: {
    WRAPPER: 'py-[25px] px-[40px] flex flex-col items-center h-full fadeIn',
    HEADING: 'font-metricR text-[24px] text-bw08 mb-[12px]',
    DISCLAIMER: 'w-full h-[215px] bg-bw02 rounded-[8px] py-[20px] px-[20px] flex flex-col',
    DISCLAIMER_HEADER: 'font-metricRMedium text-bw08 text-[16px] pb-[8px] border-b border-b-bw03',
    DISCLAIMER_BODY: 'flex grow w-full relative',
    DISCLAIMER_CONTENT: 'whitespace-pre-line font-metricR text-bw07 text-[14px]',
    SCROLLER: 'absolute inset-0 overflow-y-auto py-[8px]',
    ACTION: 'w-fit mt-auto',
  },
};

export const POSSIBLE_FORM_TYPES = ['ScheduleK', 'Form1120s', 'Form1120'];
export const INTRO_DISCLAIMER_MAP = {
  ScheduleK: {
    content: 'SCHEDULE_K_INTRO_TEXT',
    footer: 'SCHEDULE_K_INTRO_FOOTER',
  },
  Form1120s: {
    content: 'SCHEDULE_1120S_INTRO_TEXT',
    footer: '',
  },
  Form1120: {
    content: 'SCHEDULE_1120_INTRO_TEXT',
    footer: '',
  },
} as const;
export const UPGRADE_DISCLAIMER_MAP = {
  ScheduleK: {
    header: 'SCHEDULE_K_UPGRADE_HEADER',
    title: 'SCHEDULE_K_UPGRADE_TITLE',
    subtitle: 'SCHEDULE_K_UPGRADE_SUBTITLE',
    action: 'SCHEDULE_K_UPGRADE_CTA',
  },
  Form1120s: {
    header: 'SCHEDULE_1120S_UPGRADE_HEADER',
    title: 'SCHEDULE_1120S_UPGRADE_TITLE',
    subtitle: 'SCHEDULE_1120S_UPGRADE_SUBTITLE',
    action: 'SCHEDULE_1120_UPGRADE_CTA',
  },
  Form1120: {
    header: 'SCHEDULE_1120_UPGRADE_HEADER',
    title: 'SCHEDULE_1120_UPGRADE_TITLE',
    subtitle: 'SCHEDULE_1120_UPGRADE_SUBTITLE',
    action: 'SCHEDULE_1120_UPGRADE_CTA',
  },
} as const;
export const GENERATE_DISCLAIMER_MAP = {
  ScheduleK: {
    header: 'SCHEDULE_K_GENERATE_HEADER',
    subheader: 'SCHEDULE_K_GENERATE_SUBHEADER',
    content: 'SCHEDULE_K_GENERATE_CONTENT',
    action: 'SCHEDULE_K_GENERATE_CTA',
  },
  Form1120s: {
    header: 'SCHEDULE_1120S_GENERATE_HEADER',
    subheader: 'SCHEDULE_1120_GENERATE_SUBHEADER',
    content: 'SCHEDULE_1120S_GENERATE_CONTENT',
    action: 'SCHEDULE_1120S_GENERATE_CTA',
  },
  Form1120: {
    header: 'SCHEDULE_1120_GENERATE_HEADER',
    subheader: 'SCHEDULE_1120_GENERATE_SUBHEADER',
    content: 'SCHEDULE_1120_GENERATE_CONTENT',
    action: 'SCHEDULE_1120_GENERATE_CTA',
  },
} as const;
export const NAVBAR_TITLE_MAP = {
  ScheduleK: 'SCHEDULE_K_FLOW_TITLE',
  Form1120s: 'SCHEDULE_1120S_FLOW_TITLE',
  Form1120: 'SCHEDULE_1120_FLOW_TITLE',
} as const;

export const CATEGORIZE_DISCLAIMER_MAP = {
  ScheduleK: 'SCHEDULE_K_CATEGORIZE_TITLE',
  Form1120s: 'SCHEDULE_1120S_CATEGORIZE_TITLE',
  Form1120: 'SCHEDULE_1120_CATEGORIZE_TITLE',
} as const;

export const GET_FORMS_LIST_URL_MAP = {
  ScheduleK: `${BASE_URL}/api/v1/user/|customerId|/form1065`,
  Form1120s: `${BASE_URL}/api/v1/user/|customerId|/form1120`,
  Form1120: `${BASE_URL}/api/v1/user/|customerId|/form1120`,
};
export const GENERATE_FORM_URL_MAP = {
  ScheduleK: `${BASE_URL}/api/v1/user/|customerId|/form1065/|formId|/create`,
  Form1120s: `${BASE_URL}/api/v1/user/|customerId|/form1120/|formId|/create`,
  Form1120: `${BASE_URL}/api/v1/user/|customerId|/form1120/|formId|/create`,
};
export const GET_FORM_DATA_URL_MAP = {
  ScheduleK: `${BASE_URL}/api/v1/user/|customerId|/form1065/|formId|`,
  Form1120s: `${BASE_URL}/api/v1/user/|customerId|/form1120/|formId|`,
  Form1120: `${BASE_URL}/api/v1/user/|customerId|/form1120/|formId|`,
};

export const URL_PARAMS = {
  customerId: '|customerId|',
  formId: '|formId|',
};

export const GENERATE_FORM_STEPS = {
  CATEGORIZE: 'categorize',
  GENERATE: 'generate',
};
